import React, { useState } from "react";
import general from "../../options/general.json";
import ReportsExpand from "../common/ReportsExpand";
import Select from "../common/Select";
import { getYearRangeAsArray } from "./../../scripts/helperScripts";

function OhioTrainingSignIn({ isFavorite, toggleFavorite, ...rest }) {
  const [reportData, setReportData] = useState({
    month: (new Date().getMonth() + 1).toString().replace(/^0+/, ""),
    year: new Date().getFullYear().toString(),
  });

  const openReport = () => {
    const url = `https://safyreports.azurewebsites.net/Reports/OhioTraining/Signins?db=OhioTraining&m=${reportData.month}&y=${reportData.year}`;
    window.open(url, "Ohio Training Sign In Report");
  };

  const handleChange = ({ currentTarget: input }) => {
    console.log("input: ", input, input.value);
    const data = { ...reportData };
    data[input.name] = input.value;
    setReportData(data);
  };

  return (
    <ReportsExpand
      title="Ohio Training Sign Ins"
      isFavorite={isFavorite}
      toggleFavorite={toggleFavorite}
      {...rest}
    >
      <div className="row">
        <Select
          className="col col-3"
          name="CensusMonth"
          label="Month"
          options={general.month}
          value={reportData.month}
          onChange={handleChange}
        />
        <Select
          className="col col-3"
          name="CensusYear"
          label="Year"
          options={getYearRangeAsArray().map((year) => {
            const yearStr = `${year}`;
            return { _id: yearStr, name: yearStr };
          })}
          value={reportData.year}
          onChange={handleChange}
        />
        {reportData.month !== "" && reportData.year !== "" && (
          <i
            className="fas fa-arrow-circle-right fa-3x col col-2 float-end"
            onClick={openReport}
          ></i>
        )}
      </div>
    </ReportsExpand>
  );
}

export default OhioTrainingSignIn;
